import { useContext } from 'react';
import { TenantContext } from '../contexts/tenantContext';
import { TenantContextType } from '../types/tenant';

// Hook personalizado para usar o contexto
export const useTenant = (): TenantContextType => {
  const context = useContext(TenantContext);
  if (context === undefined) {
    throw new Error('useTenant deve ser usado dentro de um TenantProvider');
  }
  return context;
};
